import $ from 'jquery';

$(document).ready(function () {
  const $form = $('#scrubsForm');
  const $selectionSelect = $('#make_selection');
  const $formBody = $('#formBody');
  const $sampleProductsBlock = $('#sampleProductsBlock');
  const $commentsBlock = $('#commentsBlock');
  const $commentsInput = $('#scrubs_comments');
  const $finalHiddenInput = $('#final_sample_request');
  const $emailInput = $('#contact_email');

  const $successContact = $('#successContact');
  const $successSample = $('#successSample');

  const $headings = $('.contact__content h5');
  const $heading1 = $headings.eq(0);
  const $heading2 = $headings.eq(1);

  const $paragraphs = $('.contact__content p');
  const $p1 = $paragraphs.eq(0);
  const $p2 = $paragraphs.eq(1);
  const $p3 = $paragraphs.eq(2);

  const $requiredInputs = $(
    '#first_name, #last_name, #contact_email, #company, #postal_code, #address_one, #city, #country'
  );

  const DUPLICATE_WINDOW_MS = 2 * 60 * 1000;
  const STORAGE_KEY = 'scrubs_submission_data';

  function hideAllContent() {
    $heading1.addClass('is-hidden');
    $heading2.addClass('is-hidden');
    $p1.addClass('is-hidden');
    $p2.addClass('is-hidden');
    $p3.addClass('is-hidden');
  }

  function updateParagraphs(val) {
    hideAllContent();

    if (val === 'Request Sample') {
      $p2.removeClass('is-hidden');
      $heading2.removeClass('is-hidden');
    } else if (val === 'Contact Sales') {
      $p3.removeClass('is-hidden');
      $heading1.removeClass('is-hidden');
    } else {
      $p1.removeClass('is-hidden');
      $heading1.removeClass('is-hidden');
    }
  }

  function getStoredSubmission() {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function showDuplicateWarning(type) {
    $form.addClass('is-hidden');
    hideAllContent();

    const label =
      type === 'Request Sample' ? 'sample request' : 'sales inquiry';
    const $targetBlock =
      type === 'Request Sample' ? $successSample : $successContact;

    $targetBlock.find('h3').text('We Already Received Your Request');
    $targetBlock
      .find('p')
      .eq(0)
      .text(
        `It looks like you recently submitted a ${label} with the same information. Our team is already working on it, so there's no need to submit a duplicate. If this was a mistake or you'd like to add more information, please contact us directly.`
      );

    if (type === 'Request Sample') {
      $heading2.removeClass('is-hidden');
      $p2.removeClass('is-hidden');
    } else {
      $heading1.removeClass('is-hidden');
      $p3.removeClass('is-hidden');
    }

    $targetBlock.removeClass('is-hidden');
  }

  function showNormalSuccess(type) {
    $form.addClass('is-hidden');
    hideAllContent();

    if (type === 'Request Sample') {
      $heading2.removeClass('is-hidden');
      $p2.removeClass('is-hidden');
      $successSample.removeClass('is-hidden');
    } else {
      $heading1.removeClass('is-hidden');
      $p3.removeClass('is-hidden');
      $successContact.removeClass('is-hidden');
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const hasErrors = urlParams.get('errors') === 'true';
  const pendingSubmission = getStoredSubmission();

  if (pendingSubmission && !hasErrors) {
    const { type, email, timestamp } = pendingSubmission;
    const isRecent = Date.now() - timestamp < DUPLICATE_WINDOW_MS;

    const alreadyShownKey = `scrubs_shown_${email}`;
    const alreadyShown = sessionStorage.getItem(alreadyShownKey);

    if (alreadyShown && isRecent) {
      showDuplicateWarning(type);
    } else {
      showNormalSuccess(type);
      sessionStorage.setItem(alreadyShownKey, '1');
    }

    sessionStorage.removeItem(STORAGE_KEY);
  } else {
    if (hasErrors) {
      sessionStorage.removeItem(STORAGE_KEY);
    }

    $formBody.addClass('is-hidden');
    $sampleProductsBlock.addClass('is-hidden');
    $commentsBlock.addClass('is-hidden');

    updateParagraphs('');
  }

  $selectionSelect.on('change', function () {
    const val = $(this).val();

    $formBody.removeClass('is-hidden');
    $requiredInputs.prop('required', true);

    updateParagraphs(val);

    if (val === 'Request Sample') {
      $sampleProductsBlock.removeClass('is-hidden');
      $commentsBlock.addClass('is-hidden');
      $commentsInput.prop('required', false);
    } else {
      $sampleProductsBlock.addClass('is-hidden');
      $commentsBlock.removeClass('is-hidden');
      $commentsInput.prop('required', true);
    }
  });

  if (window.location.hash.toLowerCase() === '#request') {
    $selectionSelect.val('Request Sample').trigger('change');
  }

  $form.on('submit', function () {
    const currentVal = $selectionSelect.val();
    const email = ($emailInput.val() || '').trim().toLowerCase();

    if (currentVal === 'Request Sample') {
      const $checkedBoxes = $('.sample-checkbox:checked');

      if ($checkedBoxes.length === 0) {
        alert('Please select at least one sample product.');
        $('.sample-checkbox').first().focus();
        return false;
      }

      const values = $checkedBoxes
        .map(function () {
          return $(this).val();
        })
        .get();

      $finalHiddenInput.val(values.join(', '));

      if (!$commentsInput.val()) {
        $commentsInput.val('N/A');
      }
    } else {
      $finalHiddenInput.val(currentVal);
    }

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        type: currentVal,
        email: email,
        timestamp: Date.now(),
      })
    );
  });
});
